<!-- kodJazyk moze nadobudat hodnoty po jednotlivych jazykoch (najma pri skupinovom opakovani), inak sa rovna hodnote kodJazykRadiobox -->
<!-- 1==1 treba nahradit indexom pola -->
<div *ngFor="let kodJazykIteracia of kodJazyk.split(', '); index as index; last as last;">

  <div *ngIf="getPopisJazyk(kodJazykIteracia)"
    [ngClass]="{
      'mt-0': kodJazyk.split(', ').length > 1, 'mt-2': kodJazyk.split(', ').length === 1
    }"
    [ngStyle]="{'margin-bottom': (kodJazyk.split(', ').length > 1)
      || typZaznamuTextu.idSkupina ? '-0.5rem' : '0rem'}"
    >

    <div class="d-flex flex-row justify-content-between">

      <div class="d-flex flex-row pt-1 pe-2 text-justify">

        @switch(idDruhZaznamuTextu) {

          @case (NADPIS) {

            <h2 [ngStyle]="{'color': !typZaznamuTextu.polozkaJePlatna ? 'rgb(150,150,150)' : ''}">
              {{getKodAPopis(kodJazykIteracia)}}
            </h2>
            <span *ngIf="!typZaznamuTextu.polozkaJePlatna"
              [matTooltip]="getNeplatnaPolozkaTooltip()"
              style="cursor:default">
              *
            </span>

          }
          @case (BLOK) {

            <h3 style="font-weight:500; font-size: 121%;"
                [ngStyle]="{'color': !typZaznamuTextu.polozkaJePlatna ? 'rgb(150,150,150)' : ''}">
                {{getKodAPopis(kodJazykIteracia)}}
            </h3>
            <span *ngIf="!typZaznamuTextu.polozkaJePlatna"
              [matTooltip]="getNeplatnaPolozkaTooltip()"
              style="cursor:default">
              *
            </span>

          }

          @case (SEKCIA) {

            <h3 class="font-italic"
                [ngStyle]="{'color': !typZaznamuTextu.polozkaJePlatna ? 'rgb(150,150,150)' : ''}">
              {{getKodAPopis(kodJazykIteracia)}}
            </h3>
            <span *ngIf="!typZaznamuTextu.polozkaJePlatna"
              [matTooltip]="getNeplatnaPolozkaTooltip()"
              style="cursor:default">
              *
            </span>

          }

          @default {
              <div></div>
          }

        }

      </div>


      <div class="d-flex flex-row justify-content-end">

        @if (zobrazitButtonPrePredvyplnenieUdajov(typZaznamuTextu.id, kodJazykIteracia)) {

          <button
              mat-mini-fab color="primary" class="me-2 mb-2"
              type="button"

              (click)="openDialogNaPredvyplnenieUdajov()"
              [matTooltip]="getVyplnitUdajeTooltipText(typZaznamuTextu.id)">
              <mat-icon>library_add</mat-icon>
              <!-- <mat-icon>library_add</mat-icon> -->
          </button>

        }


        <div *ngIf="typZaznamuTextu.idSkupina && kodJazykRadiobox && kodJazykRadiobox.length > 2 && kodJazykIteracia === jazykFormulara1">
          <!-- KOPIROVACI BUTTON -->
          <button
            [ngStyle]="{'margin-right': getVysvetlivka(kodJazykIteracia) ? '-6px' : '2px', 'margin-top': '-10px'}"
            class="float-end"
            mat-icon-button
            type="button"
            (click)="skopirovatTextVJazyku1doOstatnychJazykov()"
            aria-label="Kopírovať texty"
            matTooltip="Kopírovať texty do
              {{jazykFormulara2 + (jazykFormulara3 ? ' a ' + jazykFormulara3 : '')}} položiek">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>

       <div *ngIf="getVysvetlivka(kodJazykIteracia)">

          <!-- VYSVETLIVKA SK -->
          <!-- OTAZNIK button -->
          <button
            style="margin-top: -10px; margin-right: -8px;"
            mat-icon-button
            type="button"
            (click)="zmenitZobrazenieHelpTextu(kodJazykIteracia)"
            aria-label="Help button - otaznik"
            [matTooltip]="getVysvetlivka(kodJazykIteracia)">
            <mat-icon class="help-icon">help</mat-icon>
          </button>

        </div>

      </div>



    </div>

    <div *ngIf="getDoplnPopisCely(kodJazykIteracia)" class="px-4 py-1 text-justify doplnujuci-popis-nadpis">
      {{getDoplnPopisCely(kodJazykIteracia)}}
    </div>

    <div *ngIf="zobrazitHelpText(kodJazykIteracia) && getVysvetlivka(kodJazykIteracia)"
      class="vysvetlivka-nadpis">
      {{getVysvetlivka(kodJazykIteracia)}}
    </div>

  </div>


</div>
